var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"home"}},[_c('v-layout',[_c('router-view')],1),_c('v-footer',{attrs:{"padless":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" "),_c('strong',[_vm._v("TA")]),_vm._v(" - v"+_vm._s(_vm.appVersion)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }